import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { sessionsApi } from '../services/sessionsApi'

export const useActiveSessions = () =>
  useQuery({
    queryKey: ['sessions', 'active'],
    queryFn: sessionsApi.getActive,
    refetchInterval: () =>
      typeof document !== 'undefined' && document.hidden ? false : 10000,
    retry: false,
  })

export const useTerminateSession = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (sessionId) => sessionsApi.terminate(sessionId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sessions', 'active'] }),
  })
}
